(function () {
  var AO_PREFIX = 'https://aussieoffroad.com.au/products/';
  var AO_STOCK_API = 'https://aussieoffroad.com.au/apps/crm-feedback/inventory/locations';
  var AO_SHOP = 'aussie-offroad-4x4.myshopify.com';
  var TIMEOUT_MS = 8000;
  var LABELS = {
    in_stock: ['in', 'In stock'],
    low_stock: ['low', 'Low stock'],
    pre_order: ['pre', 'Pre-order'],
    out_of_stock: ['out', 'Out of stock']
  };
  var NOTE_DEFAULT = 'Check current availability on Aussie Offroad.';
  var NOTE_UNLINKED = 'Contact Aussie Offroad or your nearest reseller to check availability.';
  var AO_CONTACT = 'https://aussieoffroad.com.au/pages/contact-us';

  function norm(s) {
    return String(s == null ? '' : s).trim().toUpperCase();
  }

  function canon(s) {
    return norm(s).replace(/[^A-Z0-9]/g, '').replace(/^RA/, '');
  }

  function getJson(url) {
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    return fetch(url, { credentials: 'omit', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) {
          var err = new Error('HTTP ' + r.status);
          err.status = r.status;
          throw err;
        }
        return r.json();
      })
      .finally(function () { if (timer) clearTimeout(timer); });
  }

  function setPill(offer, key) {
    var pill = offer.querySelector('[data-ra-pill]');
    var map = LABELS[key];
    if (!pill || !map) return false;
    pill.className = 'ra-pill ra-pill--' + map[0];
    pill.textContent = map[1];
    offer.setAttribute('data-status', map[0]);
    return true;
  }

  function resetPills(root) {
    root.querySelectorAll('.ra-offer[data-ao-location]').forEach(function (offer) {
      var pill = offer.querySelector('[data-ra-pill]');
      if (pill) {
        pill.className = 'ra-pill ra-pill--check';
        pill.textContent = 'Check availability';
      }
      offer.setAttribute('data-status', 'check');
    });
    var note = root.querySelector('[data-ra-note]');
    if (note) { note.textContent = NOTE_DEFAULT; note.hidden = false; }
  }

  function unlink(root) {
    root.setAttribute('data-ao-match', 'unverified');
    root.querySelectorAll('.ra-offer[data-ao-location]').forEach(function (offer) {
      var btn = offer.querySelector('.ra-offer__btn');
      var name = offer.querySelector('.ra-offer__name');
      if (!btn) return;
      btn.setAttribute('href', AO_CONTACT);
      btn.setAttribute('target', '_blank');
      btn.setAttribute('rel', 'noopener');
      btn.setAttribute('aria-label', 'Contact ' + (name ? name.textContent.trim() : 'Aussie Offroad') + ' to check availability (opens in a new tab)');
      if (btn.firstChild && btn.firstChild.nodeType === 3) btn.firstChild.nodeValue = 'Contact ';
    });
    var note = root.querySelector('[data-ra-note]');
    if (note) { note.textContent = NOTE_UNLINKED; note.hidden = false; }
  }

  function readVariantMap(root) {
    var el = root.querySelector('script[data-ra-variants]');
    if (!el) return null;
    try {
      var m = JSON.parse(el.textContent);
      return m && typeof m === 'object' ? m : null;
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(root) {
    var id = null;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) id = input.value;
    if (!id) {
      try {
        id = new URLSearchParams(window.location.search).get('variant');
      } catch (e) { id = null; }
    }
    return id || root.getAttribute('data-variant-id') || '';
  }

  function skuForVariant(root, variantId) {
    var map = root._raVariants;
    if (map && variantId && Object.prototype.hasOwnProperty.call(map, String(variantId))) {
      return norm(map[String(variantId)]);
    }
    if (map && variantId) return '';
    return norm(root.getAttribute('data-sku'));
  }

  function aoProduct(root, aoUrl) {
    if (!root._raAoProduct) root._raAoProduct = getJson(aoUrl + '.js');
    return root._raAoProduct;
  }

  function refresh(root) {
    var aoUrl = (root.getAttribute('data-ao-url') || '').split('#')[0].split('?')[0];
    if (aoUrl.indexOf(AO_PREFIX) !== 0 || !window.fetch) {
      root.setAttribute('data-ra-live', 'fallback');
      return;
    }
    var variantId = currentVariantId(root);
    if (root._raLastVariant === variantId && root.getAttribute('data-ra-live')) return;
    root._raLastVariant = variantId;
    var seq = (root._raSeq || 0) + 1;
    root._raSeq = seq;
    resetPills(root);
    root.removeAttribute('data-ra-live');
    var sku = skuForVariant(root, variantId);
    if (!sku) {
      root.setAttribute('data-ra-live', 'fallback');
      return;
    }
    aoProduct(root, aoUrl)
      .then(function (p) {
        var variants = (p && p.variants) || [];
        var all = root._raVariants ? Object.keys(root._raVariants).map(function (k) { return root._raVariants[k]; }) : [sku];
        var related = variants.some(function (v) {
          var a = canon(v.sku);
          return a && all.some(function (s) { return canon(s) === a; });
        });
        if (!related) {
          var e = new Error('AO product has no corresponding SKU');
          e.unlink = true;
          throw e;
        }
        var match = variants.filter(function (v) { return norm(v.sku) === sku; });
        if (match.length !== 1 || !match[0].id) throw new Error('No unique exact AO SKU match');
        var qs = 'shop=' + encodeURIComponent(AO_SHOP) + '&variantId=' + encodeURIComponent(match[0].id) + '&lowStockThreshold=3';
        return getJson(AO_STOCK_API + '?' + qs);
      })
      .then(function (data) {
        if (seq !== root._raSeq) return;
        if (!data || data.ok !== true || !Array.isArray(data.locations)) throw new Error('Bad AO stock payload');
        var updated = 0;
        root.querySelectorAll('.ra-offer[data-ao-location]').forEach(function (offer) {
          var name = offer.getAttribute('data-ao-location');
          var locs = data.locations.filter(function (l) { return l && l.name === name; });
          if (locs.length === 1 && setPill(offer, locs[0].status)) updated++;
        });
        var note = root.querySelector('[data-ra-note]');
        // Live AO statuses shown: no provenance note (Mark/Manny, RA-Website 21 Oct 2026).
        if (note && updated) note.hidden = true;
        root.setAttribute('data-ra-live', updated ? 'ok' : 'none');
      })
      .catch(function (err) {
        if (seq !== root._raSeq) return;
        resetPills(root);
        if (err && (err.unlink || err.status === 404)) unlink(root);
        else root._raAoProduct = null;
        root.setAttribute('data-ra-live', 'fallback');
      });
  }

  function init(root) {
    if (root.getAttribute('data-ra-init')) return;
    root.setAttribute('data-ra-init', '1');
    root._raVariants = readVariantMap(root);
    refresh(root);
  }

  function run() {
    document.querySelectorAll('[data-ra-resellers][data-ao-url]').forEach(init);
  }

  function onVariantMaybeChanged() {
    setTimeout(function () {
      document.querySelectorAll('[data-ra-resellers][data-ra-init]').forEach(refresh);
    }, 0);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('form[action*="/cart/add"], product-form, variant-selects, variant-radios')) onVariantMaybeChanged();
  });
  document.addEventListener('variant:change', onVariantMaybeChanged);
  window.addEventListener('popstate', onVariantMaybeChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
